<div class="page-layout-container" #container>
    <div class="page-layout-header">
        <ng-content select="app-page-header" #header></ng-content>
    </div>

    <ng-content select="app-page-side-nav"></ng-content>

    <main class="page-content" (scroll)="contentScroll.emit($event)">
        <div class="app-table-container">
            <ng-content select="app-table"></ng-content>
        </div>

        <ng-content></ng-content>
    </main>

    <div class="page-layout__bottom"
         #pageLayoutBottom
         (cdkObserveContent)="onBottomContentChanged($event)"
         [debounce]="50">
        <ng-content select="app-paginator,[appPageBottom]" #bottom />
    </div>

    <ng-content select="app-page-sidebar"></ng-content>
</div>
